import React from 'react';
import { AudioTrack } from '../types';
import AudioTrackCard from './AudioTrackCard';

type SubscriptionStatus = 'free' | 'trial' | 'active' | 'canceled' | 'past_due' | 'expired';

interface TrackListProps {
  tracks: AudioTrack[];
  onTrackSelect: (track: AudioTrack) => void;
  subscriptionStatus?: SubscriptionStatus;
  trialEndDate?: string;
  loading?: boolean;
  error?: string | null;
  onRetry?: () => void;
}

const TrackList: React.FC<TrackListProps> = ({
  tracks,
  onTrackSelect,
  subscriptionStatus = 'free',
  trialEndDate,
  loading = false,
  error = null,
  onRetry,
}) => {
  if (loading) {
    return (
      <div className='track-card-list loading'>
        <div className='text-center'>
          <div className='spinner mx-auto mb-4'></div>
          <p className='text-gray-400'>Cargando pistas...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='track-card-list error'>
        <div className='card text-center'>
          <div className='text-red-500 mb-4'>
            <svg
              className='w-12 h-12 mx-auto'
              fill='currentColor'
              viewBox='0 0 20 20'
            >
              <path
                fillRule='evenodd'
                d='M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z'
                clipRule='evenodd'
              />
            </svg>
          </div>
          <p className='track-card-header-title'>Error al cargar las pistas</p>
          <p className='text-gray-400 mb-4'>{error}</p>
          {onRetry && (
            <button onClick={onRetry} className='btn btn-primary'>
              Intentar de nuevo
            </button>
          )}
        </div>
      </div>
    );
  }

  if (tracks.length === 0) {
    return (
      <div className='track-card-list no-results'>
        <div className='text-center'>
          <div className='text-gray-500 mb-4'>
            <svg
              className='w-16 h-16 mx-auto'
              fill='currentColor'
              viewBox='0 0 20 20'
            >
              <path
                fillRule='evenodd'
                d='M9 3a1 1 0 012 0v5.5a.5.5 0 001 0V4a1 1 0 112 0v4.5a.5.5 0 001 0V6a1 1 0 112 0v5a7 7 0 11-14 0V9a1 1 0 012 0v2.5a.5.5 0 001 0V4a1 1 0 012 0v4.5a.5.5 0 001 0V3z'
                clipRule='evenodd'
              />
            </svg>
          </div>
          <p className='track-card-header-title'>No se encontraron pistas</p>
          <p className='text-gray-400'>
            No hay pistas disponibles para la categoría seleccionada.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className='track-card-list'>
      {tracks.map((track) => (
        <AudioTrackCard
          key={track.id}
          track={track}
          onSelect={onTrackSelect}
          isSelected={false}
          subscriptionStatus={subscriptionStatus}
          trialEndDate={trialEndDate}
        />
      ))}
    </div>
  );
};

export default TrackList;
